import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsToolchainRoute: InvariantJiraRoute = {
	name: 'project-settings-software-toolchain-team-managed',
	path: '/jira/software/projects/:projectKey/settings/toolchain',
	exact: true,
};
